<template>
  <div id="claim-report-add-confirm">
    <vs-row style="flex-wrap: wrap-reverse">
      <vs-col vs-lg="9" vs-sm="12">
        <common-text-large text="新規事故報告" class="mb-4" />
        <div class="vx-card p-8 h-full">
          <div class="content-between">
            <common-text-medium class="mb-8" text="事故概要" />

            <div class="px-4">
              <div class="title">
                保険契約者名<span class="required ml-2">*</span>
              </div>
              <div>{{ inputValue.overview.policyholder }}</div>
            </div>
            <vs-divider class="my-6"></vs-divider>

            <div class="px-4">
              <div class="title">
                船舶名<span class="required ml-2">*</span>
              </div>
              <div>{{ vesselName(inputValue.overview.vessel_id) }}</div>
            </div>
            <vs-divider class="my-6"></vs-divider>

            <div class="px-4">
              <div class="title">
                事故種類<span class="required ml-2">*</span>
              </div>
              <div>
                {{ accidentType(inputValue.overview.accident_type) }}
              </div>
            </div>
            <vs-divider class="my-6"></vs-divider>

            <div class="px-4">
              <div class="title">事故日</div>
              <div>{{ inputValue.overview.accident_date }}</div>
            </div>
            <vs-divider class="my-6"></vs-divider>

            <div class="px-4">
              <div class="title">事故発生時間</div>
              <div>{{ inputValue.overview.accident_time }}</div>
            </div>
            <vs-divider class="my-6"></vs-divider>

            <div class="px-4">
              <div class="title">
                事故場所<span class="required ml-2">*</span>
              </div>
              <div>{{ inputValue.overview.accident_place }}</div>
            </div>
            <vs-divider class="my-6"></vs-divider>

            <div class="px-4">
              <div class="title">
                事故概要<span class="required ml-2">*</span>
              </div>
              <div>{{ inputValue.overview.accident_summary }}</div>
            </div>
            <vs-divider class="my-6"></vs-divider>

            <div class="px-4">
              <div class="title">
                損害状況<span class="required ml-2">*</span>
              </div>
              <div>{{ inputValue.overview.damage_situation }}</div>
            </div>
            <vs-divider class="my-6"></vs-divider>

            <div class="px-4">
              <div class="title">
                自航可否<span class="required ml-2">*</span>
              </div>
              <div>{{ selfPropelled(inputValue.overview.self_propelled) }}</div>
            </div>
            <vs-divider class="my-6"></vs-divider>

            <div class="px-4">
              <div class="title">写真</div>
              <div class="w-full my-2">
                <div
                  v-for="(file, index) in pictures"
                  :key="`pictures_${index}`"
                >
                  <common-file-card
                    :file="file"
                    :showDelete="false"
                  ></common-file-card>
                </div>
              </div>
            </div>
            <vs-divider class="my-6"></vs-divider>

            <div class="px-4">
              <div class="title">フリー項目</div>
              <div>{{ inputValue.overview.free_message }}</div>
              <div class="w-full my-2">
                <div
                  v-for="(file, index) in freeFiles"
                  :key="`freefiles_${index}`"
                >
                  <common-file-card
                    :file="file"
                    :showDelete="false"
                  ></common-file-card>
                </div>
              </div>
            </div>
            <vs-divider class="my-6"></vs-divider>

            <common-text-medium class="mb-8" text="船主担当者情報" />
            <div v-for="(item, index) of this.inputValue.staff" :key="index">
              <div class="px-4 mb-2">
                <div class="title">
                  所属会社名<span class="required ml-2">*</span>
                </div>
                <div>{{ item.company_name }}</div>
              </div>

              <div class="px-4 mb-2">
                <div class="title">
                  担当窓口<span class="required ml-2">*</span>
                </div>
                <div>{{ department(item.department) }}</div>
              </div>

              <div class="px-4 mb-2">
                <div class="title">
                  船主担当者名（船主担当者）<span class="required ml-2">*</span>
                </div>
                <div>
                  <span class="mr-4">{{ item.contact_info.name }}</span>
                  <span>{{ item.contact_info.name_kana }}</span>
                </div>
              </div>

              <div class="px-4 mb-2">
                <div class="title">
                  電話番号（船主担当者）<span class="required ml-2">*</span>
                </div>
                <div>{{ item.contact_info.tel }}</div>
              </div>

              <div class="px-4 mb-2">
                <div class="title">
                  メールアドレス<span class="required ml-2">*</span>
                </div>
                <div>{{ item.contact_info.email }}</div>
              </div>
              <vs-divider class="my-6"></vs-divider>
            </div>

            <!-- button -->
            <div class="flex justify-center">
              <common-button
                title="作成画面に戻る"
                type="border"
                :color="AISEA_COLOR.GRAY"
                class="w-64 mr-4"
                :click="cancel"
              ></common-button>
              <common-button
                title="送信"
                class="w-64"
                :click="submit"
              ></common-button>
            </div>
          </div>
        </div>
      </vs-col>
      <vs-col class="right-widget-area" vs-lg="3" vs-sm="12"> </vs-col>
    </vs-row>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("hullInsuranceAddReport");
import { ColorMixin, HullInsranceMixin } from "@/mixins";

import {
  HULL_INSURANCE_ACCIDENT_TYPE,
  HULL_INSURANCE_CONTACT_INFO,
  HULL_INSURANCE_SELF_PROPELLED,
} from "@/config/const";

import CommonTextLarge from "../components/atoms/CommonTextLarge.vue";
import CommonTextMedium from "../components/atoms/CommonTextMedium.vue";
import CommonButton from "../components/molecules/CommonButton.vue";
import CommonFileCard from "../components/molecules/CommonFileCard.vue";

import { AiseaApiFactory } from "@/api/aisea/apiFactory";
const claimReportRepository = AiseaApiFactory.get(
  "hullInsuranceEnterpriseClaimReport"
);

import { FileUtil } from "@/utils";
import Vue from "vue";

export default {
  name: "T.ClaimReportAddConfirm",
  mixins: [ColorMixin, HullInsranceMixin],
  components: {
    CommonTextLarge,
    CommonTextMedium,
    CommonButton,
    CommonFileCard,
  },
  computed: {
    ...mapState(["inputValue", "vessels", "pictures", "freeFiles"]),
  },
  methods: {
    vesselName(id) {
      const vessel = this.vessels.find(item => {
        return item.vessel_id === id;
      });

      if (!vessel || !vessel.label) return "";

      return vessel.label;
    },

    accidentType(type) {
      const _type = HULL_INSURANCE_ACCIDENT_TYPE[type];
      if (!_type) return "";
      return _type.label;
    },

    department(id) {
      const _department = HULL_INSURANCE_CONTACT_INFO.find(item => {
        return item.id === id;
      });
      return _department.label;
    },

    selfPropelled(value) {
      return HULL_INSURANCE_SELF_PROPELLED.find(item => item.value === value)
        .label;
    },

    notifyError(msg) {
      Vue.$log.error(msg);
      const text = msg ? msg : "エラーが発生しました。";
      this.$vs.notify({
        title: "エラー",
        text: text,
        color: "danger",
      });
    },

    async uploadFiles(item_name, files) {
      const promiseAll = await files.map(async item => {
        let formData = new FormData();
        const file = FileUtil.toBlob(item.src, item.type);
        formData.append("file", file, item.name);
        return await claimReportRepository.addReportFile(item_name, formData);
      });
      const res = await Promise.all(promiseAll);

      return res.map(item => {
        if (!item || !item.status) return;
        return item.data;
      });
    },

    async submit() {
      try {
        //書類アップロードAPI送信
        if (this.pictures && this.pictures.length > 0) {
          const files = await this.uploadFiles("pictures", this.pictures);
          this.inputValue.overview.pictures = files;
        }

        if (this.freeFiles && this.freeFiles.length > 0) {
          const files = await this.uploadFiles("free_files", this.freeFiles);
          this.inputValue.overview.free_files = files;
        }

        //事故報告APIを送る
        this.postReport();
      } catch (error) {
        this.notifyError(error);
      }

      this.$router.push({
        name: "hull-insurance-claim-report-add-complete",
      });
    },

    async postReport() {
      const res = await claimReportRepository.add(this.inputValue);

      if (!res) {
        throw null;
      }

      if (!res.status) {
        throw res.data.message;
      }
    },
    cancel() {
      this.$router.push({
        name: "hull-insurance-claim-report-add",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/aisea/_variables.scss";
@import "@/assets/scss/aisea/_typography.scss";
@import "@/assets/scss/aisea/hull-insurance.scss";

#claim-report-add-confirm {
  font-family: $aisea-font-family;
  .title {
    font-weight: bold;
  }
  .required {
    color: $aisea-red;
  }
}
</style>
